

// Custom hook to detect bottom visibility
import {useEffect, useRef, useState} from "react";

const TESTING_VISIBILITY = false;
const useBottomVisibility = ({ onLoad = false, offset = 200 } = {}) => {
    const [isBottomVisible, setIsBottomVisible] = useState(false);
    const [wasBottomVisibleOnLoad, setWasBottomVisibleOnLoad] = useState(false);
    const [hasCheckedInitialVisibility, setHasCheckedInitialVisibility] = useState(!onLoad);
    const containerRef = useRef(null);
    const bottomMarkerRef = useRef(null);

    useEffect(() => {
        const marker = bottomMarkerRef.current;
        if (!marker) return;

        // Check initial visibility if onLoad is true
        if (onLoad && !hasCheckedInitialVisibility) {
            const rect = marker.getBoundingClientRect();
            const isVisible = rect.top + offset <= window.innerHeight;
            setWasBottomVisibleOnLoad(isVisible);
            setHasCheckedInitialVisibility(true);
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsBottomVisible(entry.isIntersecting);
            },
            {
                root: null,
                rootMargin: '-200px',
                threshold: 0.1
            }
        );

        observer.observe(marker);
        return () => observer.disconnect();
    }, [onLoad, hasCheckedInitialVisibility]);

    return {
        containerRef,
        bottomMarkerRef,
        isBottomVisible,
        wasBottomVisibleOnLoad,
        hasCheckedInitialVisibility,
        bottomMarkerStyle: TESTING_VISIBILITY ? {background: `linear-gradient(90deg, transparent 0%, ${isBottomVisible ? '#34D399' : '#EF4444'} 50%, transparent 100%)`} : {}
    };
};
export default useBottomVisibility;